// extracted by mini-css-extract-plugin
export default {"card":"Card_card__pF8op","card__title":"Card_card__title__4Mc-B","cardContent":"Card_cardContent__vaPh+","cardContent__item":"Card_cardContent__item__Eq1rr"};